import { getPatient, getPractice } from 'library/auth';
import { getGreeting } from './helper';

const Greeting = () => (
  <div className="shrink-0">
    <h1 className="text-xl font-bold leading-tight text-secondary-900 sm:text-2xl">
      {getGreeting()}, {getPatient()?.full_name?.split(' ')[0] || 'there'}
    </h1>
    <p className="mt-1 text-sm text-secondary-400">Here&apos;s what&apos;s coming up at {getPractice()?.title}.</p>
  </div>
);

export default Greeting;
